<template>
  <div class="pulse-loader">
    <div
      v-for="i in 3"
      :key="i"
      class="pulse-dot"
      :style="{
        backgroundColor: color,
        width: size,
        height: size,
        animationDelay: `${(i - 1) * 0.12}s`
      }"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  color?: string
  size?: string
}

withDefaults(defineProps<Props>(), {
  color: '#D0D0D0',
  size: '15px'
})
</script>

<style scoped>
.pulse-loader {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.pulse-dot {
  border-radius: 50%;
  animation: pulseScale 1s infinite ease-in-out both;
}

@keyframes pulseScale {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
</style>
